'use client'
import React, { useEffect, useState } from 'react'

import { Spinner } from '@nextui-org/react'

import CardSS, { FeedProvider } from '@/components/shared/ContentFeed/CardSS'
import { useScrollBottom } from '@/hooks'
import { useGetFeedQuery } from '@/redux/api/feed/feed.w3api'
import fakeData from '@/utils/fakeData'
import SkeletonFeed from '@/components/shared/ContentFeed/CardSS/SkeletonFeed'
import BlurButton from '@/components/motion/BlurBtn'

export const ListPost = () => {
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false)
  const [page, setPage] = useState(1)

  const { data: feedData, isFetching } = useGetFeedQuery({ page: page, size: 6, searchType: 'all', sort: 'DESC' })

  const isBottom = useScrollBottom(feedData)
  useEffect(() => {
    if (isBottom && !isFetching && feedData?.meta?.hasNext) {
      setIsLoadingMore(true)
      setPage((prev) => prev + 1)
    } else {
      setIsLoadingMore(false)
    }
  }, [isBottom, feedData?.meta?.hasNext, isFetching])
  return (
    <BlurButton>
      <div>
        <FeedProvider data={feedData?.data}>
          <CardSS />
        </FeedProvider>

        {isFetching && (
          <div className="flex w-full flex-col gap-4 px-3">
            {fakeData(5).map((_, i: number) => (
              <SkeletonFeed key={i} index={i} />
            ))}
          </div>
        )}
        {isLoadingMore && (
          <div className="flex items-center justify-center">
            <Spinner className="flex items-center justify-center" />
          </div>
        )}
      </div>
    </BlurButton>
  )
}
